module.exports = __webpack_public_path__ + "static/media/startImage.c453f279.png";